<template>
  <Gallery
    :images="[
      require('@/assets/img/sports/IMG_9475-1200w.jpg'),
      require('@/assets/img/sports/IMG_9478-1200w.jpg'),
      require('@/assets/img/sports/IMG_9483-1200w.jpg'),
    ]"
  />
</template>

<script>
import Gallery from '@/components/Gallery.vue'

export default {
  name: 'Sports',
  components: {
    Gallery
  }
}
</script>
